<template>
  <div
    id="app"
    class="flex flex-row bg-gray-100"
    :style="loadingpage ? 'background-color: #fff;' : ''"
  >
    <Login v-if="!login"> </Login>
    <template>
      <side-bar
        v-if="
          login &&
          user.status &&
          user.status == 'active' &&
          $route.name != 'createStore' &&
          $route.name != 'errorPage'
        "
        :user="user"
        :idWharhouse="idWharhouse"
      ></side-bar>
      <main
        v-if="login && user.status"
        :class="
          !ShowSidebar() || resize() || $route.name == 'errorPage'
            ? 'mll-0'
            : ''
        "
        class="flex ml-5 flex-col flex-auto w-full min-w-0"
      >
        <top-bar
          v-if="$route.name != 'createStore' && $route.name != 'errorPage'"
          :user="user"
          :idWharhouse="idWharhouse"
          :sous_idWharhouse="sous_idWharhouse"
          :sous_warehouses="sous_warehouses"
          class="sticky top-0"
        ></top-bar>
        <vue-progress-bar></vue-progress-bar>
        <router-view
          :currentUser="user"
          :idWharhouse="idWharhouse"
          :sous_idWharhouse="sous_idWharhouse"
          :sous_warehouses="sous_warehouses"
        />
        <div
          v-if="$route.name != 'createStore' && $route.name != 'errorPage'"
          class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent"
        >
          <span class="font-medium text-secondary"
            >ShipSen © {{ new Date().getFullYear() }}</span
          >
        </div>
        <vue-modal-2
          name="ModalFormation"
          :headerOptions="{ title: 'Formation videos' }"
          :noFooter="true"
          modalSize="xl"
          @on-close="closeModal()"
        >
          <div class="bg-white rounded-lg">
            <div class="relative">
              <div class="rounded-lg flex">
                <div class="intro-y pt-0 w-full news p-5 box">
                  <h2 class="intro-y font-medium text-xl sm:text-2xl">
                    Simplification d'utilisation de multi-warehouses
                  </h2>
                  <div class="rwd-media mt-3"></div>
                </div>
              </div>
            </div>
          </div>
        </vue-modal-2>
      </main>
      <vue-modal-2
        name="RefreshPage"
        :headerOptions="{ title: `Mettre à jour Shipsen.` }"
        :noFooter="true"
        modalSize="md"
      >
        <div class="bg-white rounded-lg">
          <div class="rounded-lg">
            <p class="p-4 pt-0 font-bold text-center">
              <img
                class="fill-current mr-1 inline-block"
                src="https://img.icons8.com/external-kosonicon-solid-kosonicon/48/null/external-reloading-arrows-set-2-kosonicon-solid-kosonicon-4.png"
              />
            </p>
            <p class="p-4 pt-0 font-bold text-center">
              Une nouvelle mise à jour améliorée de l'application est maintenant
              disponible, actualiser la page SVP.
            </p>
          </div>
          <div class="p-4 w-full text-right">
            <button
              @click="RefreshPage()"
              class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-blue-700 hover:text-white font-bold text-sm loidingconfirm relative"
            >
              <i
                style="vertical-align: middle"
                class="material-icons text-white mr-1"
                >refresh</i
              >
              Actualiser maintenant
            </button>
          </div>
        </div>
      </vue-modal-2>
    </template>
    <div v-if="loadingpage" id="loadingpage">
      <div class="loader loader-mixed">
        <div class="spinner-ball-outer"></div>
        <div class="spinner-ball-inner"></div>
      </div>
      <div class="loading-info">Loading Shipsen ...</div>
    </div>
    <!-- <div v-if="loadingpage" class="loading-panel" id="loader" style="">
        <div class="loader loader-mixed">
          <div class="spinner-ball-outer"></div>
          <div class="spinner-ball-inner"></div>
        </div>
        <div class="loading-info">Loading data ...</div>
     </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      login: false,
      user: {},
      typeUser: "",
      Curruser: {},
      idWharhouse: null,
      sous_idWharhouse: null,
      sous_warehouses: [],
      loadingpage: false,
    };
  },
  async mounted() {
    console.log(
      "sous selected--------",
      this.$store.state.wharhouse.sous_warhouseSelected
    );
    await this.getAccess();
    //this.openClosePopup('open');
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.loadingpage = false;
      }
    };
  },
  created() {
    if (document.readyState == "loading") {
      this.loadingpage = true;
    }
    let vm = this;
    document.addEventListener("readystatechange", function (ev) {
      if (document.readyState == "complete") {
        setTimeout(function () {
          vm.loadingpage = false;
        }, 800);
      }
    });
  },
  computed: {
    itemsSousWarehousesLength() {
      return this.$store.state.sous_warehouses.length;
    },
  },
  watch: {
    "$store.getters.loadingpage": async function (oldVal, newVal) {
      console.log("new loading-----", oldVal);
      this.loadingpage = oldVal;
    },
    "$store.state.update": async function (oldVal, newVal) {
      console.log("new update data mise ajour-----", oldVal);
      console.log(
        "new update pr_version mise ajour-----",
        this.$store.state.pr_version
      );
      //if (oldVal) this.openClosePopup("open");
    },
    "$store.state.countryW": async function (oldVal, newVal) {
      console.log("new countryW mise ajour-----", oldVal);
    },
    "$store.state.wharhouse.warhouseSelected": {
      async handler(newValue, oldValue) {
        console.log("oldValue--------", newValue);
        await this.getwharhouseId(newValue.country || newValue);
        console.log("country--------", newValue);
        console.log("id ware--------", this.idWharhouse);
      },
      deep: true,
    },
    "$store.state.wharhouse.sous_warhouseSelected": {
      async handler(newValue, oldValue) {
        console.log("oldValue sous_warhouseSelected--------", newValue);
        this.sous_idWharhouse = newValue;
      },
      deep: true,
    },
    // '$store.state.sous_warehouses.length': {
    //       handler: function () {
    //           console.log('lenght sous_warehouses changed!');
    //       },
    //       deep: true
    //   },
    itemsSousWarehousesLength(val, oldVal) {
      console.log(
        "lenght sous_warehouses changed!",
        this.$store.state.sous_warehouses
      );
      if (this.$store.state.sous_warehouses) {
        this.sous_warehouses = this.$store.state.sous_warehouses;
        console.log("sous_warehouses changed!", this.sous_warehouses);
      }
    },
  },
  methods: {
    ShowSidebar() {
      return this.$store.getters.ShowSidebar;
    },
    closeModal() {
      this.$vm2.close("ModalFormation");
      this.pauseVideo();
    },
    openClosePopup(type) {
      console.log("type-----", type);
      if (type == "open") {
        console.log("open modal-----", type);
        this.$vm2.open("RefreshPage");
      } else this.$vm2.close("RefreshPage");
    },
    async RefreshPage() {
      console.log(
        "new update pr_version mise ajour-----",
        this.$store.state.pr_version
      );
      if (this.user && this.user._id) {
        this.user.isRefreshPage = true;
        const dataa = await this.$server.update(
          "users",
          _.pick(this.user, ["_id", "isRefreshPage"])
        );
        if (dataa && dataa._id) {
          const res = await this.$me;
          console.log("countryW-----", localStorage.getItem("countryW"));
          console.log("warehouses-----", dataa.warehouses);
          const dataW = dataa.warehouses.find(
            (o) => o.country === localStorage.getItem("countryW")
          );
          console.log("dataW-----", dataW);
          if (!dataW) {
            this.$store.dispatch("wharhouse/changeWrahouse", {
              warhouse: dataa.warehouses[0].country || dataa.warehouses[0],
            });
            localStorage.setItem(
              "countryW",
              dataa.warehouses[0].country || dataa.warehouses[0]
            );
          }
          localStorage.setItem("pr-version", this.$store.state.pr_version);
          window.location.reload();
        } else alert(dataa, "warning");
      }
    },
    pauseVideo() {
      var iframe = document.getElementById("video");
      // $f == Froogaloop
      var player = $f(iframe);

      var pauseButton = document.getElementById("click-to-close");
      // it is now hidden, we can't access it anymore...
      player.api("pause");
    },
    async changeWrahouse(warhouse) {
      console.log("changeWrahouse---------------", warhouse);
      this.$store.dispatch("wharhouse/changeWrahouse", {
        warhouse: warhouse.country,
      });
      this.idWharhouse = warhouse;
      localStorage.setItem("countryW", warhouse.country);
    },
    async getwharhouseId(country) {
      // if(this.login) await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
      const resW = await this.$server.get("warehouses", { country: country });
      if (resW && resW.content) {
        this.idWharhouse = resW.content;
      }
    },
    resize() {
      return this.$store.getters.resize;
    },
    async getAccess() {
      this.loading = true;
      const tokenExist = this.$jwtService.verifyToken();
      if (tokenExist) {
        const token = this.$jwtService.getToken();
        const dataUser = await this.$me;
        if (dataUser && dataUser.status && dataUser.status == 200) {
          this.typeUser = dataUser.content.type;
          this.user = dataUser.content;

          this.$store.dispatch("actionSeller", { user: this.user });
          const resW = await this.$server.get("warehouses", {
            country: this.$store.state.wharhouse.warhouseSelected,
          });
          if (resW && resW.content) this.idWharhouse = resW.content;
          if (
            ["Admin", "Administrateur","Subscription"].indexOf(
              this.user.type
            ) != -1
          ) {
            const resW = await this.$server.search("warehouses", {
              country: this.idWharhouse.country,
              all: true,
              limit: 100,
            });
            if (resW.content && resW.content.results) {
              this.user.sous_warehouses = resW.content.results
                .filter((item) => !item.is_primary)
                .sort((a, b) => (a._id > b._id ? 1 : b._id > a._id ? -1 : 0));
              this.sous_warehouses = this.user.sous_warehouses.map(
                (warehouse) => ({ _id: warehouse._id, name: warehouse.name })
              );
              if (this.sous_warehouses && this.sous_warehouses.length > 0)
                this.sous_warehouses.splice(0, 0, { _id: "all", name: "all" });
              this.$store.dispatch("actionSousWarehouses", {
                sous_warehouses: this.sous_warehouses,
              });
            }
          } else {
           if(this.user.type != 'Seller') this.user.sous_warehouses = this.sous_warehouses = [];
          }
          this.sous_idWharhouse =
            (await this.$store.getters["wharhouse/sous_warhouseSelected"]({
              user: _.pick(this.user, ["sous_warehouses", "type"]),
            })) || null;
          // console.log('sous_idWharhouse---------------',this.sous_idWharhouse)
          this.login = true;
        }
      }
      this.loading = false;
    },
  },
};
</script>
<style>
.flex-shrink-0 {
  flex-shrink: 0;
}
.me-2 {
  margin-right: 0.5rem;
}
.animation-pulse {
  -webkit-animation: shadow-pulse 1s infinite;
  animation: shadow-pulse 1s infinite;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(30, 112, 185);
  }
  100% {
    box-shadow: 0 0 0 15px rgba(0, 0, 0, 0);
  }
}
.callsettings .vs__dropdown-toggle {
  flex-wrap: wrap;
}
.callsettings .vs__actions {
  position: absolute;
  right: 0;
  top: 10px;
}
.loading-excel span {
  animation-name: blinkdot;
  animation-duration: 1.4s;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
  font-weight: 900;
  vertical-align: text-bottom;
}
.loading-excel span:nth-child(2) {
  animation-delay: 0.2s;
}
.loading-excel span:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes blinkdot {
  0% {
    opacity: 0.2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
.select2-selection__rendered {
  box-sizing: border-box;
  list-style: none;
  margin: 0;
  width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.select2-selection__rendered li {
  list-style: none;
  border-radius: 4px;
  cursor: default;
  float: left;
  margin-right: 5px;
  padding: 0 5px;
  background-color: #f1f5fa !important;
  border: 1px solid #eaf0f7 !important;
  font-size: 8px;
}
.select2-container--default {
  background-color: white;
  border-radius: 4px;
  cursor: text;
  height: 100% !important;
  line-height: 18px !important;
  box-sizing: border-box;
  display: block;
  min-height: 20px;
  user-select: none;
  -webkit-user-select: none;
  order: 1px solid #eaf0f7 !important;
}
.mll-4 {
  margin-left: 4em;
}
.ware_prin {
  position: relative;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 15px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin-left: 7px;
}
.ware_prin::before {
  position: absolute;
  top: 47px;
  left: 0;
  width: 53px;
  height: 1px;
  margin: auto;
  content: "";
  background-color: #666;
}
.ware_prin::after {
  height: 47px;
}
.ware_prin::after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 1px;
  content: "";
  background-color: #666;
}
#vm2_box_RefreshPage .vm2__close,
#vm2_box_ModalSettings .vm2__close {
  display: none;
}
#vm2_box_modalConfirm .vm2__close,
#vm2_box_modal-confirm .vm2__close,
#vm2_box_myModalUnrached .vm2__close,
#vm2_box_myModalRemonded .vm2__close,
#vm2_box_myModalDepot .vm2__close,
#vm2_box_myModalCancel .vm2__close,
#vm2_box_myModalLogs .vm2__close {
  display: none;
}
#vm2_box_myModalLogs {
  min-height: 600px;
}
.tooltip {
  display: block;
  z-index: 10000;
}
.isProcessed {
  display: none !important;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}
.qu-textAlign--center {
  text-align: center;
  z-index: 11;
  word-break: break-word;
  cursor: pointer;
}
.qu-wordBreak--break-word {
  word-break: break-word;
}
.gCrsNT {
  appearance: none !important;
  border-radius: 1000px;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  white-space: nowrap;
  cursor: pointer;
  background-color: #f7f7f8;
}
.qu-justifyContent--center {
  justify-content: center;
}
.qu-alignItems--center {
  align-items: center;
}
.qu-medium {
  font-weight: 500;
}
.qu-overflow--hidden {
  overflow: hidden;
}
.qu-display--inline-flex {
  display: inline-flex;
}
.qu-color--gray {
  color: #636466;
}
.qu-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
}
.qu-whiteSpace--nowrap {
  white-space: nowrap;
}
.qu-width--16 {
  width: 16px;
}
.qu-height--16 {
  height: 16px;
}
.qu-mr--n_tiny {
  margin-right: -4px;
}
.qu-ml--tiny {
  margin-left: 4px;
}
.dvqCYw {
  display: inline-flex;
  -moz-box-align: center;
  align-items: center;
  -moz-box-pack: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  vertical-align: top;
}
.dvqCYw svg {
  width: 16px;
  height: 16px;
  vertical-align: top;
}
#vm2__cover_wrapper_myModal .vm2_body,
#vm2__cover_wrapper_ModalProducts .vm2_body,
#vm2__cover_wrapper_updateorders .vm2_body {
  overflow-y: inherit;
  max-height: initial;
}
.header-table.th-1 {
  background-color: #d4ebff;
  height: 35px;
}
.h-30 {
  height: 30px;
}
.table-p {
  border-spacing: 0 10px;
  border-collapse: separate;
}
.table-p tr {
  box-shadow: 20px 3px 20px rgba(0, 0, 0, 0.043137254901960784);
}
.ql-editor {
  min-height: 140px !important;
}

.ql-snow .ql-formats:nth-child(3),
.ql-snow .ql-formats:nth-child(4),
.ql-snow .ql-formats:nth-child(5),
.ql-snow .ql-formats:nth-child(6),
.ql-snow .ql-formats:nth-child(7),
.ql-snow .ql-formats:nth-child(8),
.ql-snow .ql-formats:nth-child(9) {
  display: none !important;
}
.ql-snow .ql-formats:nth-child(8) .ql-link,.ql-snow .ql-formats:nth-child(8) .ql-video{
  display: none !important;
}

.notification-editor .ql-editor img {
  max-width: 100%;
  display: block;
}

.ql-editor {
  min-height: 200px;
}

.sous-s {
  color: #646878;
  background-color: #eff1f2;
  font-weight: 600;
  align-items: center;
  margin-top: 2px;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 5px;
  padding: 1px 10px;
  font-size: 10px;
  display: block;
}
.table-p td {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.bottom_bitt {
  overflow-y: auto;
  max-height: 500px;
  padding-bottom: 90px;
}
.icone-img {
  display: inline-block;
  width: 20px;
  vertical-align: sub;
  padding-right: 4px;
}
.img-paym {
  display: inline-block;
  width: 20px;
}
#vm2_box_Echange,
#vm2_box_EditOrder,
#vm2_box_updateorders {
  background-color: #f2f2f2 !important;
}
#vm2_box_Echange .vm2__close,
#vm2_box_EditOrder .vm2__close,
#vm2_box_updateorders .vm2__close,
#vm2_box_Modalprocessaid .vm2__close {
  display: none !important;
}
.data-ss {
  border-top-right-radius: 8px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 8px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1), 0 0 1px 0 rgba(0, 0, 0, 0.1);
  background-color: rgba(255, 255, 255, 1);
  font-size: 12px;
  line-height: 1.28;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  box-sizing: border-box;
  position: relative;
  padding: 15px;
  overflow-x: auto;
  overflow-y: auto;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
}
.row-data {
  margin-bottom: 8px;
  margin-top: 5px;
}
.row-data .title-1 {
  font-weight: 400;
  word-wrap: normal;
  color: rgba(0, 0, 0, 0.85);
  white-space: inherit;
  font-size: 0.875rem !important;
}
.row-data .content-1 {
  text-align: left;
  color: rgba(0, 0, 0, 0.75);
  font-weight: 700;
  word-wrap: normal;
  font-size: 0.875rem !important;
}
.header-1 {
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: row;
  display: flex;
  font-size: 12px;
  line-height: 1.28;
}
.header-1 .content {
  box-sizing: border-box;
  height: 60px;
}
.header-1 .title {
  white-space: nowrap;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  text-align: left;
  text-overflow: ellipsis;
  color: rgba(0, 0, 0, 0.75);
  font-weight: 700;
  font-size: 1.125rem !important;
  line-height: 1.33334 !important;
}
.header-1 .content-1 {
  white-space: nowrap;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  font-weight: normal;
  text-overflow: ellipsis;
  color: rgba(0, 0, 0, 0.75);
  word-wrap: normal;
  line-height: 1.42858 !important;
  font-size: 0.875rem !important;
}
.header-table {
  width: 100%;
  display: flex;
  align-items: center;
  height: 48px;
  box-sizing: border-box;
  padding-top: 10px;
  padding-bottom: 10px;
  box-shadow: inset 0 -1px 0 #dadcde;
  border-top: 1px solid #cecdcd;
}
.header-table .title {
  display: flex;
  align-items: center;
  min-width: 0;
  text-align: left;
  color: rgba(0, 0, 0, 0.75);
  font-weight: 700;
  word-wrap: normal;
  line-height: 1.42858;
  white-space: inherit;
  font-size: 0.875rem;
}
.header-table .title-1 {
  font-weight: 400 !important;
}
.xz84dc7 {
  width: 60%;
}
.x8yj6t5 {
  width: 20%;
}
.x8yj6t5 {
  width: 20%;
}

.xz84dc7z {
  width: 60%;
}
.x8yj6t5z {
  width: 15%;
}
.x8yj6t5z {
  width: 15%;
}

.xz84dc7p {
  width: 10%;
}
.header-table .w-12 {
  width: 2rem;
}
.loading-panel {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 16em;
  min-height: 8.75em;
  margin-top: -4.3em;
  margin-left: -8em;
  font-size: 14px;
  animation: zoom 0.3s 1 linear, fadein 0.5s 1 linear;
}
#loadingpage .loader {
  position: absolute;
  z-index: 30;
  left: 50%;
  width: 88px;
  margin-left: -44px;
}
#loadingpage .loader .spinner-ball-outer,
.ecwid-loadingIndicator .loader .spinner-ball-outer {
  width: 88px;
  height: 88px;
  background: transparent
    url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='88' height='88' viewBox='0 0 88 88'%3E%3Cpath fill='none' stroke='%23275ce0' stroke-linecap='round' stroke-width='3' d='M64.8 79.5C58.4 83.3 51 85.5 43 85.5 27 85.5 13 76.6 5.8 63.5M64.4 6.2C77 13.6 85.5 27.3 85.5 43 85.5 50.7 83.4 58 79.8 64.2M.5 43C.5 19.5 19.5.5 43 .5' transform='translate(1 1)'/%3E%3C/svg%3E")
    center center no-repeat;
  background-size: contain;
  animation: spinright 0.8s infinite linear;
}

#loadingpage .loader .spinner-ball-inner,
.ecwid-loadingIndicator .loader .spinner-ball-inner {
  width: 40px;
  height: 40px;
  margin: -64px auto 64px;
  background: transparent
    url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40'%3E%3Cpath fill='%23275ce0' d='M20 39.5C9.2 39.5.5 30.8.5 20S9.2.5 20 .5 39.5 9.2 39.5 20c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5c0-9.1-7.4-16.5-16.5-16.5S3.5 10.9 3.5 20 10.9 36.5 20 36.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z'/%3E%3C/svg%3E")
    center center no-repeat;
  background-size: contain;
  animation: spinleft 0.5s infinite linear;
}
#loadingpage .loading-info {
  position: absolute;
  width: 100%;
  margin-top: 6em;
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #0a1c2e;
}
@keyframes spinleft {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes spinright {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.spinner-container {
  width: 100%;
  height: 100%;
  z-index: 99999;
  text-align: center;
}
.spinner {
  margin: auto;
  border: 2px solid #dbf2ff;
  /*
  change to dotted for something cool.
  change width to 1px for tapered bar
  */
  width: 32px;
  height: 32px;
  display: inline-block;
  position: absolute;
  top: 45%;
  border-radius: 50%;
  border-right: 2px solid #018df7;
  text-align: center;
  animation-name: spin;
  animation-duration: 900ms;
  animation-iteration-count: infinite;
  /*animation-timing-function: linear; /*linear spin */
  animation-timing-function: cubic-bezier(0.53, 0.21, 0.29, 0.67);
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  /*50% {width:24px;height:24px} /*shrinking effect*/
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  /*50% {width:24px;height:24px} /*shrinking effect*/
  100% {
    -webkit-transform: rotate(360deg);
  }
}
body {
  position: relative;
}
.access_pages .vs__selected-options {
  flex-wrap: wrap !important;
}
.tag_cities {
  width: 100%;
  max-width: 100%;
}
.tag_cities .tag {
  background: rgb(49 130 206 / 16%);
  border-radius: 20px;
  float: left;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 500;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-right: 2px;
  margin-bottom: 5px;
  min-height: 28px;
  padding-right: 10px;
  color: rgba(0, 0, 0, 0.7);
  position: relative;
  padding-right: 0;
}
.vs-chip--text {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-left: 10px;
}
.vs-chip--close {
  width: 20px;
  height: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 50%;
  border: 0;
  margin: 0 4px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.15);
  color: #fff;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  cursor: pointer;
}
.tag_cities .tag [data-role="remove"]::after {
  content: "x";
  padding: 0px 2px;
  margin-bottom: 3px;
  font-size: 15px;
}
.tag_cities .tag [data-role="remove"] {
  margin-left: 8px;
  cursor: pointer;
}
.noselect {
  pointer-events: none;
}
.label-accept {
  background: #e22ae6;
}
.label-sucess {
  background: #0ba006;
}
.label-blue {
    background: #3182ce;
}
.qr-wrapper {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
}

.qr-wrapper-small {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 1px;
}

/* Print Optimization */
@media print {
  .qr-wrapper canvas,
  .qr-wrapper-small canvas {
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    page-break-inside: avoid;
  }
  
  .modalprint table {
    page-break-inside: auto;
  }
  
  .modalprint tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }
} 
.jvectormap-tip {
  padding: 3px 6px 3px;
  font-size: 10px;
  border-radius: 50px;
  text-transform: capitalize;
  font-weight: 400;
  display: block;
  margin-top: 4px;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
}
.vue-slider .vue-slider-rail {
  background: #eee;
  background: linear-gradient(to bottom, #ddd -50%, #fff 150%);
  height: 10px;
  border: 1px solid #ccc;
  border-radius: 16px;
}
.vue-slider-process {
  background-color: #0450c2;
}
.divider.margin {
  margin: 8px 48px;
}
.header-ware {
  /* min-width: 190px; */
}
.ware-item {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.divider {
  cursor: default;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  border-radius: 2px;
  padding: 0 10px;
}
.invoice-detail-body .content-block {
  padding-left: 48px;
  padding-right: 48px;
}
.invoice-totals-container {
  position: relative;
  width: 100%;
  margin-top: 8px;
  overflow: auto;
}
.invoice-totals-container .invoice-totals-row.desktop {
  padding-right: 40px;
}
.invoice-totals-container .invoice-totals-row {
  width: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: end;
  justify-content: flex-end;
}
.invoice-totals-container .invoice-summary-label {
  margin-left: 0;
  text-align: right;
}
.invoice-totals-container .invoice-totals-row.desktop .invoice-summary-value {
  padding: 0 0.25rem;
}
.invoice-totals-container .invoice-summary-value {
  min-width: 130px;
  text-align: right;
}
.invoice-totals-container .invoice-totals-row.bold {
  font-weight: 500;
  font-size: 1.1rem;
}
.invoice-detail-body .content-block {
  padding-left: 48px;
  padding-right: 48px;
}
.invoice-item-list .table {
  margin-bottom: 0;
}
.invoice-item-list .table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}
.invoice-item-list table {
  border-collapse: collapse;
}
.invoice-item-list table thead tr {
  text-transform: uppercase;
  padding: 0.8rem 0;
  font-weight: 700;
  border-top: 1px solid;
  border-bottom: 1px solid;
  font-size: 1rem;
}
.invoice-item-list .table th.invoice-detail-margin {
  width: 8px;
  max-width: 8px;
}
.invoice-item-list .table th {
  text-align: right;
}
.invoice-item-list .table th {
  padding: 0.7rem 0.5rem;
  border: none;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  vertical-align: top;
  background: #3182ce4f;
}
.invoice-item-list .table th.invoice-detail-summary {
  text-align: left;
  width: 100%;
}
.invoice-item-list .table th {
  padding: 0.7rem 0.5rem;
  border: none;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
}
.invoice-items tr {
  border-bottom: 1px dashed #7b7878;
}
.item-row {
  -webkit-transition: -webkit-transform 0.5s ease-out;
  transition: -webkit-transform 0.5s ease-out;
  -o-transition: transform 0.5s ease-out;
  transition: transform 0.5s ease-out;
  transition: transform 0.5s ease-out, -webkit-transform 0.5s ease-out;
}
.invoice-item-list .table td {
  border: none;
  padding-top: 8px;
  padding-bottom: 0;
  text-align: center;
  vertical-align: middle;
}
.invoice-item-list .table td,
.invoice-item-list .table th {
  padding: 0.25rem;
  text-align: left;
}
.invoice-item-list .table td,
.invoice-item-list .table th {
  vertical-align: top;
}
.item-row-amount,
.item-row-quantity,
.item-row-rate {
  text-align: right;
  min-width: 120px;
}
.item-row .item-row-actions {
  width: 50px;
}
.app-theme .btn {
  -webkit-font-smoothing: antialiased;
  font-weight: 500;
  color: #555;
  background: #f4f4f4;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#f4f4f4),
    to(#e4e4e4)
  );
  background: -o-linear-gradient(#f4f4f4, #e4e4e4);
  background: linear-gradient(#f4f4f4, #e4e4e4);
  border-radius: 3px;
  border: 1px solid #999;
  display: inline-block;
  padding: 4px;
  overflow: hidden;
  text-decoration: none;
  min-width: 30px;
  cursor: pointer;
  -webkit-transition: ease-in 0.1s;
  -o-transition: ease-in 0.1s;
  transition: ease-in 0.1s;
  font-size: inherit;
}
svg:not(:root).svg-inline--fa {
  overflow: visible;
}
.svg-inline--fa.fa-w-11 {
  width: 0.6875em;
}
.svg-inline--fa {
  display: inline-block;
  font-size: inherit;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.invoice-item-list .table td.item-row-summary,
.invoice-item-list .table th.invoice-detail-summary {
  text-align: left;
  width: 50%;
}
.item-row-name {
  display: block;
}
.item-row input {
  border-top: 1px solid #ccc;
  border-radius: 3px;
}
.invoice-item-list .table td {
  border: none;
  padding-top: 8px;
  padding-bottom: 0;
}
.invoice-item-list .table td,
.invoice-item-list .table th {
  padding: 0.25rem;
}
.react-autosuggest__container {
  position: relative;
}
.item-row input {
  border-top: 1px solid #ccc;
}
.other-fees {
  font-size: 12px;
  text-transform: uppercase;
  border-bottom: 2px solid #333;
  color: #333;
  padding: 30px 0 5px 0;
  margin-bottom: 5px;
  font-weight: 600;
}
.app-theme input {
  background-color: #fff;
  border: 1px solid #aaa;
  padding: 8px 16px;
  width: 100%;
  -webkit-transition: ease-in 0.1s;
  -o-transition: ease-in 0.1s;
  transition: ease-in 0.1s;
}

.item-row-amount .edit,
.item-row-quantity .edit,
.item-row-rate .edit {
  line-height: 32px;
}
.localized-number {
  font-size: 14px;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
}
.invoice-items tr.item-row-n {
  border: none;
}
.item-row .item-row-actions {
  width: 50px;
}
.item-row .item-row-actions .btn {
  min-width: 35px;
  padding: 4px;
}
.item-row .btn.btn-prime {
  background: #444;
  background: linear-gradient(#555, #444);
  color: #fff;
  font-weight: 500;
}
.app-theme .btn.btn-prime {
  background: #444;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#555),
    to(#444)
  );
  background: -o-linear-gradient(#555, #444);
  background: linear-gradient(#555, #444);
  color: #fff;
  font-weight: 500;
}
.item-row-name input {
  width: 100%;
  margin-bottom: 5px;
  background-color: #fff;
  border: 1px solid #aaa;
  border-radius: 3px;
  padding: 8px 16px;
  -webkit-transition: ease-in 0.1s;
  -o-transition: ease-in 0.1s;
  transition: ease-in 0.1s;
}
.dropdown_warhouse {
  max-height: 19vh;
  background: #fff;
  overflow-y: scroll;
}
/* total width */
.dropdown_warhouse::-webkit-scrollbar {
  background-color: #fff;
  width: 16px;
}

/* background of the scrollbar except button or resizer */
.scroldropdown_warhouselbar::-webkit-scrollbar-track {
  background-color: #fff;
}
.dropdown_warhouse::-webkit-scrollbar-track:hover {
  background-color: #f4f4f4;
}

/* scrollbar itself */
.dropdown_warhouse::-webkit-scrollbar-thumb {
  background-color: #babac0;
  border-radius: 16px;
  border: 5px solid #fff;
}
.dropdown_warhouse::-webkit-scrollbar-thumb:hover {
  background-color: #a0a0a5;
  border: 4px solid #f4f4f4;
}

/* set button(top and bottom of the scrollbar) */
.dropdown_warhouse::-webkit-scrollbar-button {
  display: none;
}

.fz-10 {
  font-size: 10px;
}
.z-1 {
  z-index: 1;
}
.voyage-info {
  position: relative;
  display: table;
  width: 90%;
  table-layout: fixed;
  margin: 0 auto;
  border-collapse: collapse;
}
.voyage-info .segments {
  display: table-row;
}
.voyage-info .segments .departure {
  padding: 0 8px 0 0;
}
.voyage-info .segments .segment {
  background: #fff;
  position: relative;
  z-index: 2;
  padding: 0 8px;
}
.voyage-info .segments > div {
  display: table-cell;
  text-align: center;
  position: relative;
}
.voyage-info .segments time {
  font-weight: bold;
  font-size: 12px;
  line-height: 30px;
}
.voyage-info .segments .bus {
  display: block;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.4);
  line-height: 16px;
}
.voyage-info .segments .bus:only-child {
  line-height: 30px;
}
.voyage-info::after {
  display: block !important;
}
.voyage-info::after {
  content: "";
  width: 100%;
  height: 1px;
  position: absolute;
  top: 20px;
  display: block;
  background: #666;
  z-index: 0;
}
.voyage-info .segments .destination {
  padding: 0 0 0 8px;
}
div.clc-jobs-multi.tagged {
  line-height: 140%;
  position: relative;
}
div.clc-jobs-multi.blue,
div.clc-jobs-multi.blue .slanted-bg {
  background-image: linear-gradient(89.81deg, #0678f4 41.01%, #37b2df 99.64%);
  background-position: center 0px;
}
div.clc-jobs-multi {
  font-size: 12px;
  text-align: left;
  padding: 1px;
  clear: both;
  background-repeat: no-repeat;
  border-radius: 3px;
  box-sizing: border-box;
}
div.clc-jobs-multi.blue .header,
div.clc-jobs-multi.blue .slanted-bg .header {
  padding: 7px 12px 10px;
}
div.clc-jobs-multi .header {
  font-size: 19px;
  color: white;
  line-height: 25px;
  padding: 10px 12px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  display: flex !important;
}
.fl1 {
  flex: 1 auto !important;
}
div.clc-jobs-multi .header .header-icon-right {
  z-index: 1;
}
div.clc-jobs-multi.blue .header .header-icon-right svg,
div.clc-jobs-multi.blue .slanted-bg .header .header-icon-right svg {
  position: absolute;
  top: 8px;
  right: 5px;
}
div.clc-jobs-multi .header .header-icon-right svg {
  width: 64px;
  height: 35px;
  fill: #fff;
}
.svg-icon {
  vertical-align: bottom;
}
div.clc-jobs-multi > .middle {
  background: white;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
}
.font-w-normal {
  font-weight: normal !important;
}
.color-orange {
  color: #ff6900 !important;
}
.duree {
  width: 205px !important;
}
.w-full-imp {
  width: 100% !important;
}
.div-filters .mx-input {
  box-shadow: none;
  border: none;
}
.adaptive {
  width: 75px;
}
.loidingconfirm svg {
  width: 30px;
}
.btn-disable {
  cursor: not-allowed;
  pointer-events: none;
}
.align-sub {
  vertical-align: sub;
}
.statistics-box .vs__search {
  margin: 0;
}
.vs__selected-options {
  flex-wrap: inherit;
}

.lds-facebook {
  display: inline-block;
  position: relative;
  width: 60px;
  height: 50px;
}
.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 8px;
  width: 16px;
  background: #a7a9a7;
  animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}
.lds-facebook div:nth-child(1) {
  left: 8px;
  animation-delay: -0.24s;
}
.lds-facebook div:nth-child(2) {
  left: 32px;
  animation-delay: -0.12s;
}
.lds-facebook div:nth-child(3) {
  left: 56px;
  animation-delay: 0;
}
@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 64px;
  }
  50%,
  100% {
    top: 24px;
    height: 32px;
  }
}
p.Note {
  font-size: 12px;
  background-color: #f6f6f6;
  padding: 11px;
  display: block;
  margin-bottom: 10px;
}
.rwd-media {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%; /* 16:9 */
}

.rwd-media iframe,
.rwd-media video {
  position: absolute;
  width: 100%;
  height: 100%;
}
.btn-bottom-toolbar {
  position: fixed;
  bottom: 0;
  padding: 12px;
  padding-right: 50px;
  margin: 0px 0 0 -40px;
  box-shadow: 0 -4px 1px -4px rgb(0 0 0 / 10%);
  background: #fff;
  width: calc(100% - 211px);
  z-index: 60;
  border-top: 1px solid #ededed;
}
i.tiny {
  font-size: 12px;
  line-height: 20px;
}
i.small {
  font-size: 2rem;
}
.main-body {
  margin-left: 0 !important;
}
.h-14 {
  height: 3.5rem !important;
}
.modal-footer {
  overflow: auto;
  position: absolute;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 -4px 1px -4px rgb(0 0 0 / 10%);
  border-top: 1px solid #ededed;
  padding-top: 15px;
  padding-bottom: 15px;
  z-index: 12;
}
.btnn {
  border-radius: 0.375rem;
  border-width: 1px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition-property: background-color, border-color, color, fill, stroke,
    opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: background-color, border-color, color, fill, stroke,
    opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: background-color, border-color, color, fill, stroke,
    opacity, box-shadow, transform, filter, backdrop-filter,
    -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.15s;
  transition-duration: 0.2s;
}
.mb-13 {
  margin-bottom: 4rem;
}
.mb-14 {
  margin-bottom: 5rem;
}
.mll-0 {
  margin-left: 0 !important;
}
.vm2__header h4 {
  pointer-events: none;
}
.disabled {
  pointer-events: none;
  color: #bfcbd9;
  cursor: not-allowed;
  background-image: none;
  background-color: #eef1f6;
  border-color: #d1dbe5;
}
.vs__dropdown-toggle {
  border: none;
}
.flag-img {
  display: inline-block;
  height: 16px;
  width: 16px;
  vertical-align: text-top;
  line-height: 16px;
  margin-right: 5px;
}
.vm2__header h4,
.vm2__header .vm2__close {
  font-weight: 600;
}
.vm2_wrapper {
  z-index: 11;
}
.vm2_body {
  max-height: 500px;
}
.v-select .vs__selected {
  white-space: nowrap !important;
}
.v-select .vs__dropdown-toggle {
  overflow-x: hidden !important;
}
.form-checkbox {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  flex-shrink: 0;
  color: currentColor;
  background-color: #fff;
  border-color: #e2e8f0;
  border-width: 1px;
  border-radius: 0.25rem;
  height: 1.2em;
  width: 1.2em;
}

.form-checkbox:checked {
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z'/%3e%3c/svg%3e");
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.overflow-visible {
  white-space: initial;
}
.alert-dialog {
  position: fixed;
  transform: translate(-50%, -50%);
  z-index: 9990;
  padding: 15px 25px;
  color: #444444;
  background-color: white;
  box-shadow: 0 15px 30px 5px #00000045;
  border-radius: 35px;
  cursor: pointer;
}
.alert-dialog.fadein {
  animation: fadein 1s;
}
.alert-dialog.fadeout {
  animation: fadeout 1s;
}
@keyframes fadein {
  0% {
    opacity: 0;
    transform: translate(-50%, 50%);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}
@keyframes fadeout {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, 50%);
  }
}
/*  Mobile css */
.mat-icon-button {
  padding: 0;
  min-width: 0;
  width: 35px;
  height: 35px;
  flex-shrink: 0;
  border-radius: 50%;
  box-sizing: border-box;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  outline: none;
  border: none;
  -webkit-tap-highlight-color: transparent;
  display: inline-block;
  white-space: nowrap;
  text-decoration: none;
  vertical-align: baseline;
  text-align: center;
  margin: 0;
  overflow: visible;
}
#loadingpage {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.97;
  background-color: #fff;
  z-index: 10000;
}
.lds-spinner {
  color: official;
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  z-index: 100;
}
.lds-spinner div {
  transform-origin: 40px 40px;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 37px;
  width: 6px;
  height: 18px;
  border-radius: 20%;
  background: #0087b4;
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.btn-marketing {
  border-color: rgb(0 143 188/1);
  background-color: rgb(0 159 209/1);
  color: rgb(255 255 255/1);
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px -1px rgb(0 0 0 / 10%);
  -webkit-animation: shadow-pulse 1s infinite;
  animation: shadow-pulse 1s infinite;
}
.btn-marketing {
  cursor: pointer;
  border-radius: 0.375rem;
  border-width: 1px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.5rem;
  font-weight: 500;
  box-shadow: 0 0 #0000, 0 0 #0000;
  transition-property: color, background-color, border-color, fill, stroke,
    opacity, box-shadow, transform, filter, -webkit-text-decoration-color,
    -webkit-backdrop-filter;
  transition-property: color, background-color, border-color,
    text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter,
    backdrop-filter;
  transition-property: color, background-color, border-color,
    text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter,
    backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(30, 112, 185);
  }
  100% {
    box-shadow: 0 0 0 15px rgba(0, 0, 0, 0);
  }
}
.tabs-component-tabs {
  border: solid 1px #504e4e;
  border-radius: 6px;
  margin-bottom: 5px;
}

@media (min-width: 700px) {
  .tabs-component-tabs {
    border: 0;
    align-items: stretch;
    display: flex;
    justify-content: flex-start;
    margin-bottom: -1px;
  }
}

.tabs-component-tab {
  color: #999;
  font-size: 14px;
  font-weight: 600;
  margin-right: 0;
  list-style: none;
}

.tabs-component-tab:not(:last-child) {
  border-bottom: dotted 1px #ddd;
}

.tabs-component-tab:hover {
  color: #666;
}

.tabs-component-tab.is-active {
  color: #000;
}

.tabs-component-tab.is-disabled * {
  color: #cdcdcd;
  cursor: not-allowed !important;
}

@media (min-width: 700px) {
  .tabs-component-tab {
    background-color: #fff;
    border: solid 1px #504e4e;
    border-radius: 3px 3px 0 0;
    margin-right: 0.5em;
    transform: translateY(2px);
    transition: transform 0.3s ease;
  }

  .tabs-component-tab.is-active {
    border-bottom: solid 1px #fff;
    z-index: 2;
    transform: translateY(0);
  }
}

.tabs-component-tab-a {
  align-items: center;
  color: inherit;
  display: flex;
  padding: 0.75em 1em;
  text-decoration: none;
}

.tabs-component-panels {
  padding: 1em 0;
}

@media (min-width: 700px) {
  .tabs-component-panels {
    border-top-left-radius: 0;
    background-color: #fff;
    border: solid 1px #504e4e;
    border-radius: 0 6px 6px 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    padding: 1em 1em;
  }
}
</style>
